import React from 'react'
import Wwa from '../../assets/children/wwa3.png'
function OurPromise() {
  return (
    <div className=' my-[64px] about-us grid sm:grid-cols-2 px-6 py-[64px] sm:px-[88px]  gap-8 '>
       
        <div className=' sm:pt-12'>
        <h1 className='text-[35px] lg:text-[45px] text-[#102343] font-[700]'>
        Our Promise
        </h1>
        <p className='text-[18px] lg:text-[28px] font-[500]  mt-3'>
        To nurture the children in our care by equipping them with skills to be independent and to flourish
        within the society.
        <br></br><br></br>
        We are registered as a charitable organisation with the Association of Orphanages and Home
        Operators in Nigeria and the Association for Orphans and Vulnerable Children in Nigeria.
        </p>
        </div>
        <div>
        <img src={Wwa} alt='WWA'/>
        </div>
    </div>
  )
}

export default OurPromise